const DEFAULT_COGNITO_AUTHORITY =
  "https://cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_bTXBD1xbZ";

export function resolveCognitoAuthority(environment) {
  return environment.REACT_APP_COGNITO_AUTHORITY || DEFAULT_COGNITO_AUTHORITY;
}

export function resolveCognitoScope() {
  return "openid profile email";
}
